export default "__VITE_ASSET__DY0Sg8Fy__"